<template>
    <div>
        <ul v-if="!$Func.isEmptyArray(data)" class="text-14 color-65 cursor-pointer">
            <li v-for="(item, index) in data" :key="'list' + index" :class="{ active: active === index }" @click="setAcitve(item, index)" class="py-4 px-16 mb-4 radius-4">
                {{ item[name] }}
            </li>
        </ul>
        <div v-else class="flex-x-center">
            暂无数据...
        </div>
    </div>
</template>

<script>
export default {
    name: 'DList',
    props: {
        data: { type: Array, default: () => [] },
        name: { type: String, default: 'name' }
    },
    data() {
        return {
            active: 0
        };
    },
    watch: {
        data(val) {
            this.setAcitve(val[0], 0);
        }
    },
    methods: {
        setAcitve(data, index) {
            this.active = index;
            this.$emit('change', data);
        }
    }
};
</script>
<style>
.active {
	background: rgba(69, 158, 63, 0.1);
}
</style>
